<template>
  <div class="container overflow-hidden ">
    <div class="row gx-5">
      <div class="col-3">
        <div class=" border bg-light">
          <div class="col">
            <div class="divider" />
            <div class="md-2">
              <button
                type="button"
                class="btn btn-success mt-2 ml-0"
                @click="updateSubmit()"
              >Salvar</button>
              <router-link
                :to="`/player/${this.vslId}/customizacao`"
                class="btn btn-outline-secondary  mt-2 ml-1"
              >
                Voltar
              </router-link>
            </div>

          </div>
          <div class="divider" />
          <div class="">

            <h2>
              <feather-icon
                icon="AirplayIcon"
                size="28"
                stroke="Aquamarine"
                class="mr-50"
              /> Continuar
              Assistindo
            </h2>
          </div>
          <div class="divider" />
          <div class="container ">
            <form @submit.prevent="updateSubmit()">
              <div class="row" id="mensagem-continuar-assistindo">

                <h3>Mensagem</h3>
                <div class="form-floating md-2">
                  <textarea
                    id="floatingTextarea"
                    v-model="viewer[0].viewer_message"
                    class="form-control"
                    placeholder="Leave a comment here"
                    style="height: 87px"
                  />
                  <label for="floatingTextarea" />
                </div>
              </div>
              <div class="divider" />

              <div class="row" id="botao-continuar-assistindo">
                <h3>Botão continuar</h3>
                <div class="md-2">
                  <input
                    v-model="viewer[0].viewer_bt_continue"
                    type="text"
                    class="form-control "
                    required
                  >
                </div>
              </div>
              <div class="divider" />
              <div class="row" id="botao-recomecar-assistindo">
                <h3>Botão recomeçar</h3>
                <div class="md-2">
                  <input
                    v-model="viewer[0].viewer_bt_restart"
                    type="text"
                    class="form-control "
                    required
                  >
                </div>
              </div>
              <div class="divider" />
              <div class="row" id="cores-continuar-assistindo">
                <h3>Cores</h3>

                <div
                  class="ant-col"
                  style="flex: 1 1 auto; min-width: 0px;"
                >
                  <span
                    class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line colorText___Jqdck"
                  >Cor
                    do texto
                  </span>
                  <input
                    v-model="viewer[0].viewer_color_text"
                    class="tb rounded float-end"
                    type="color"
                    onchange="changeColor();"
                  >
                </div>
                <div class="divider" />

                <div
                  class="ant-col"
                  style="flex: 1 1 auto; min-width: 0px;"
                >
                  <span
                    class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line colorText___Jqdck"
                  >Background
                  </span>
                  <input
                    v-model="viewer[0].viewer_back_color"
                    class="tb rounded float-end"
                    type="color"
                    onchange="changeColor();"
                  >
                </div>
              </div>
            </form>
          </div>
          <div class="divider" />
        </div>
      </div>
      <div class="col player">
        <video
          class="player"
          src="https://dkplayer.s3.sa-east-1.amazonaws.com/emerson_matos-Id1/UploadFolderVideos/DKP/e9b113d23c4b0d9980b4-Segurança e performance.mp4"
          preload="auto"
        />
        <div
          class="continuarContainer"
          :style="'background-color:' + viewer[0].viewer_back_color"
        >
          <div class="continuarTop">
            <div
              :style="'color:' + viewer[0].viewer_color_text + ';display: flex; flex-direction: column; align-items: center; font-size: 22px;margin-top: 130px;' "
            >
              {{ viewer[0].viewer_message }}
            </div>

          </div>
          <div class="continuarMiddle">
            <div class="continuarLeft">
              <div
                :style="'color:' + viewer[0].viewer_color_text + ';display: flex; flex-direction: column; align-items: center; font-size: 22px;margin-top: 60px;' "
              >
                <svg
                  height="15%"
                  viewBox="0 0 464 464"
                  width="15%"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m464 232c0 128.128906-103.871094 232-232 232s-232-103.871094-232-232 103.871094-232 232-232 232 103.871094 232 232zm0 0"
                    :fill="dadosVideo.backgroundColor"
                  />
                  <path
                    d="m152 328 192-96-192-96zm0 0"
                    fill="#f1f2f2"
                  />
                </svg>
                {{ viewer[0].viewer_bt_continue }}
              </div>
            </div>
            <div class="continarRight">
              <div
                :style="'color:' + viewer[0].viewer_color_text + ';display: flex; flex-direction: column; align-items: center; font-size: 22px;margin-top: 60px;' "
              >
                <svg
                  height="15%"
                  viewBox="0 0 64 64"
                  width="15%"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Refresh">
                    <path
                      :fill="dadosVideo.backgroundColor"
                      d="m56 36a24.00021 24.00021 0 1 1 -47.97949-1.00244c.16514-3.97153 6.15982-3.711 5.99512.249a18.00052 18.00052 0 1 0 19.059-17.19421l2.96441 2.74743c2.96684 2.74871-1.2349 7.03676-4.07812 4.4004l-7.55323-7a4.34547 4.34547 0 0 1 -.00048-6.4004l7.55371-7c2.90563-2.69524 6.98974 1.70285 4.07812 4.4004l-3.047 2.824a23.98055 23.98055 0 0 1 23.00796 23.97582z"
                    />
                  </g>
                </svg>
                {{ viewer[0].viewer_bt_restart }}
              </div>
            </div>
          </div>
        </div>
        <div class="barra-progresso" />
      </div>
    </div>
  </div>
</template>

<script>

import { ViewerService } from '@/services/Viewer'
import Detalhes from '../../EditarVideo/Detalhes.vue'

export default {
  components:
        { Detalhes },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      vslId: this.$route.params.vslId,
      loading: false,
      viewer: {
        viewer_message: '',
        viewer_bt_restart: '',
        viewer_bt_continue: '',
        viewer_back_color: '',
        viewer_color_text: '',
        id_vsl: 13,
      },
      errorMessage: null,
      viewer: [],
      dadosVideo: [],

    }
  },
  async created() {
    try {
      this.loading = true
      const response = await ViewerService.getViewerVSL_Id(this.vslId)
      console.log(this.vslId)
      this.viewer = response.data
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  methods: {
    jsonPersonalizado() {
      console.log('oi')
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json[0]
            console.log(this.dadosVideo)
          }
        })
    },
    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/viewer/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"viewer_message":"${this.viewer[0].viewer_message
        }","viewer_bt_restart":"${this.viewer[0].viewer_bt_restart
        }","viewer_bt_continue":"${this.viewer[0].viewer_bt_continue
        }","viewer_back_color":"${this.viewer[0].viewer_back_color
        }","viewer_color_text":"${this.viewer[0].viewer_color_text
        }","id_vsl":"${this.vslId}"}`,
      })

        .then(response => {
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })

        .catch(err => console.error(err))
    },
  },

}

</script>
<style scoped>
.tb {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin: 0px;
    border: none;
}
.player {
    width: 112%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.player:fullcreen {
    max-width: none;
    width: 100%;
}

.player:-webkit-full-screen {
    max-width: none;
    width: 100%;
}

.player:-ms-full-screen {
    max-width: none;
    width: 100%;
}

.player:-moz-full-screen {
    max-width: none;
    width: 100%;
}

.barra_controle {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    transform: translateY(100%) translateY(-15px);
    transition: all .3s;
    flex-wrap: wrap;
    background: rgba(0, 0, 0, .2);
}

.barra-progresso {
    position: absolute;
    bottom: 3px;
    left: 0;
    width: 0%;
    height: 10px;
    opacity: 0.7;
    transition: width 0.3s;
    background-color: rgb(255, 157, 0);
}

.player:hover .barra_controle {
    transform: translateY(0);
}

.barra_controle>* {
    flex: 1;
}

.progress {
    flex: 10;
    position: relative;
    display: flex;
    flex-basis: 100%;
    height: 10px;
    transition: height .3s;
    background: rgba(0, 0, 0, .25);
    cursor: pointer;
    /* ew-resize*/
}

.player_my_button {
    background: none;
    border: 0;
    line-height: 1;
    color: white;
    text-align: center;
    outline: 0;
    padding: 10px 15px 10px 15px;
    cursor: pointer;
    max-width: 50px;

}

.playerSlider {
    display: block;
    width: 10px;
    height: 30px;
}

.fullscreenbtn {
    background: none;
    border: 0;
    line-height: 1;

    outline: 0;
    padding: 10px 20px 20px 10px;
    cursor: pointer;
    max-width: 50px;
    position: absolute;
    right: 0;

}

.playpause {
    background-color: rgba(178, 34, 34, 0);
    border-radius: 50px;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 10 !important;
}

.playpause {
    opacity: 1;
    transition: opacity 400ms;
}

.playpause[hidden] {
    opacity: 0;
    display: block;
}

.divContinuarCentro {
    display: flex;
    width: 70%;
    height: 70%;
    padding: 30% 10% 10% 10%;
}

.imgContinuar {
    width: 30px;
    height: 30px;
    padding: 10px 10px 10px 10px;
}

.overlayTransparente {
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.263);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: "pointer";
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.inicial {
    border: 2px solid rgb(255, 255, 255);
    border-radius: 15px 50px;
    width: 50%;
    height: 50%;
    position: absolute;
    flex-direction: column-reverse;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    background-size: contain;
    background-position: center;
    background: rgba(212, 144, 7, 0.929);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.continuarContainer {
    top: 0;
    left: 13px;

    position: absolute;
    display: flex;
    width: 97%;
    height: 99%;
    cursor: pointer;
    flex-direction: column;
    align-items: center;
}

.continuarTop {
    width: 100%;
    font-size: 32px;
    font-family: Arial, sans-serif;
    text-align: center;
    margin-bottom: 2%;
    margin-top: 2%;
}

.continuarMiddle {
    display: flex;
    width: 100%;
    font-size: 32px;
    font-family: Arial, sans-serif;
}

.continuarLeft {
    width: 50%;
    font-size: 32px;
    text-align: center;
    justify-items: center;
    align-content: center;
    align-self: center;
    /* background-color: rgb(234, 137, 137); */
}

.continarRight {
    width: 50%;
    font-size: 32px;
    text-align: center;
    /* background-color: #555; */
}

.imgContinuarLeft {
    align-items: center;
}

/* .continuar {
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    cursor: pointer;
    /* align-items: center; */
/* top: 0;
    flex-direction: column;
  } */

/* .video-banner {
    position: relative;
  }
  .video-banner .overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    z-index: 1;
  } */

.loader {
    height: 70px;
    width: 200px;
    display: flex;
    align-items: center;
}

.loader .stroke {
    display: block;
    position: relative;
    background: #f1f1f1;
    height: 50%;
    width: 15%;
    border-radius: 50px;
    margin: 0 5px;
    align-items: center;
    animation: animate 1.2s linear infinite;
}

.playImagem {
    width: 64px;
    height: 64px;
    cursor: pointer;
}

.textoContinuarAssistindo {
    position: absolute;
    align-self: center;
    font-size: 42px;
    top: 20px;
    color: #f1f1f1;
    padding: 50px 50px 50px 50px;
    font-family: Arial, Helvetica, sans-serif;
}

.textoInicialSuperior {
    background-color: #555;
    position: absolute;
    align-self: center;
    color: #f1f1f1;
    font-size: '52px';
    font-family: Arial, Helvetica, sans-serif;
}

.textoInicialInferior {
    position: absolute;
    align-self: center;
    bottom: 20px;
    color: #f1f1f1;
    font-size: '52px';
    font-family: Arial, Helvetica, sans-serif;
}

/* @keyframes animate {
    50% {
      height: 20%;
    }
    100% {
      height: 100%;
    }
  }

  .stroke:nth-child(1) {
    animation-delay: 0s;
  }
  .stroke:nth-child(2) {
    animation-delay: 0.3s;
  }
  .stroke:nth-child(3) {
    animation-delay: 0.6s;
  }
  .stroke:nth-child(4) {
    animation-delay: 0.9s;
  }
  .stroke:nth-child(5) {
    animation-delay: 0.6s;
  }
  .stroke:nth-child(6) {
    animation-delay: 0;
  }
  .stroke:nth-child(7) {
    animation-delay: 0.2s;
  }
  .stroke:nth-child(8) {
    animation-delay: 0.5s;
  }
  .stroke:nth-child(9) {
    animation-delay: 0.1s;
  }
  .stroke:nth-child(10) {
    animation-delay: 0s;
  }
  .stroke:nth-child(11) {
    animation-delay: 0.3s;
  }
  .stroke:nth-child(12) {
    animation-delay: 0.6s;
  }
  .stroke:nth-child(13) {
    animation-delay: 0.3s;
  }

  #context-menu {
    position: fixed;
    width: 170px;
    height: 20px;
    border: #000;
    background: rgba(40, 38, 38, 0.856);
    transform: scale(0);
    transform-origin: top left;
    padding: 8px 8px 8px 8px;
  }

  #context-menu.active {
    transform: scale(1);
    transition: transform 200ms ease-in-out;
  }

  #context-menu a {
    font-size: 15px;
    font-family: Arial, Helvetica, sans-serif;
    color: #eee;
    text-decoration: none;
  }

  #context-menu .item:hover {
    background: #555;
  }
  .playpausebg {

    background-repeat: no-repeat;
    width: 102%;
    height: 128%;
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 2 !important;
  }

  .playpausebg {
    opacity: 1;
    transition: opacity 400ms;
  }

  .playpausebg[hidden] {
    opacity: 0;
    display: block;
  }
  .playEndedbg {

    background-repeat: no-repeat;
    width: 102%;
    height: 128%;
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 2 !important;
  }

  .playEndedbg {
    opacity: 1;
    transition: opacity 400ms;
  }

  .playEndedbg[hidden] {
    opacity: 0;
    display: block;
  }

  #video {
    position: relative;
  }

  .waveform {
    animation: waveform 5s linear infinite;
  }
  @keyframes waveform {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  } */

.startTop {
    width: 100%;
    margin-top: 2%;
    font-size: 32px;
    text-align: center;
    font-family: Arial, sans-serif;
}

.starMiddle {
    width: 50%;
    font-size: 32px;
    margin-top: 2%;
    background-color: lightblue;
    text-align: center;
}

.startBotton {
    width: 50%;
    font-size: 32px;
    margin-top: 2%;
    background-color: lightgreen;
    text-align: center;
}
</style>
